<template>
  <div style="width: 740px;margin: 0 auto;border:1px solid;box-shadow: 5px 5px 5px #888888;">
    <div id="content" style="width: 640px;margin: 0 auto;">
      <p style="margin:6pt 0pt 0pt; text-align:justify">
        <span style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span>
      </p>
      <p style="margin:0pt 0pt 6pt; orphans:0; text-align:right; widows:0">
        <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">合同编号：</span>
        <span class="content">{{contract.code}}</span>
        <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"> </span>
      </p>
      <p style="margin:6pt 0pt; orphans:0; text-align:center; widows:0"><span
          style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:楷体; font-size:24pt; font-weight:bold">购销协议</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:justify"><span
          style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center">
        <span class="content">{{contract.name}}</span>
      </p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:14pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:楷体; font-size:18pt; font-weight:bold">与</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:14pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:楷体; font-size:14pt; font-weight:bold">{{contract.Bname}}</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:justify"><span
          style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:12pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:6pt 0pt 0pt; text-align:center">
        <span style="font-family:楷体; font-size:10.5pt; font-weight:bold">北京市朝阳区</span>
      </p>
      <p style="margin:6pt 0pt 0pt; text-align:center">
        <span class="content">{{contract.year}}</span>
        <span style="font-family:楷体; font-size:10.5pt; font-weight:bold">年</span>
        <span class="content">{{contract.month}}</span>
        <span style="font-family:楷体; font-size:10.5pt; font-weight:bold">月</span>
        <span class="content">{{contract.day}}</span>
        <span style="font-family:楷体; font-size:10.5pt; font-weight:bold">日</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
          style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span></p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span style="font-family:楷体; font-size:10.5pt">本《购销协议》（以下简称“<b>本协议</b>”）由以下双方在<b>北京市朝阳区</b>签署：</span>
      </p>

      <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
          style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">甲方：</span>
        <span class="content">{{contract.Aname}}</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">地址：</span>
        <span class="content">{{contract.Aaddress}}</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">联系人：</span>
        <span class="content">{{contract.Auser}}</span>
      </p>
      <!--<p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">电话：</span>
        <span class="content">{{contract.Amobile}}</span>
      </p>-->
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">邮箱：</span>
        <span class="content">{{contract.Aemail}}</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span style="font-family:楷体; font-size:10.5pt; font-weight:normal">乙方：</span>
        <span class="content">{{contract.Bname}}</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">地址：</span>
        <span class="content">{{contract.Baddress}}</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">联系人：</span>
        <span class="content">{{contract.Buser}}</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">电话：</span>
        <span class="content">{{contract.Bmobile}}</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span  style="font-family:楷体; font-size:10.5pt; font-weight:normal">邮箱：</span>
        <span class="content">{{contract.Bemail}}</span>
      </p>
      <p style="margin:0.8pt 0pt 0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span style="font-family:楷体; font-size:10.5pt"><b>&nbsp;&nbsp;&nbsp;&nbsp;双方特此声明，各方已仔细阅读本合同内容，充分理解各条款含义。双方同意本合同可通过双方线下盖章签署，或双方代表人通过指定的电子邮箱、微信、短信、飞书信息等网络信息确认的方式签署，或通过第三方电子签名服务机构以电子签名方式签署，当双方使用电子签名方式签署或通过网络信息确认的方式签署本合同后，即表示双方已充分阅读、理解并接受本合同全部内容，本合同在甲乙双方之间生效，产生完整的法律效力，与以线下盖章方式完成签署的合同具备同等法律效力。</b></span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span style="font-family:楷体; font-size:10.5pt">&nbsp;&nbsp;&nbsp;&nbsp;甲、乙双方依据《中华人民共和国民法典》及相关规定，在平等自愿的基础上，经协商一致，签署本协议，内容如下：</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify">
        <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>

      <ol type="1" style="margin:0pt; padding-left:0pt">
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">服务内容、范围</span>
          <p style="margin:0pt; text-align:justify">
            <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist1" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">产品：</span>
              <span style="font-family:华文楷体; font-size:10.5pt">指乙方依据本协议为甲方供应的货物，包括但不限于图书、服装、配饰、婴儿食品用品、美妆用品等，具体以实际销售推广的为准。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">终端客户：</span>
              <span style="font-family:华文楷体; font-size:10.5pt">指通过乙方或其转售方最终购买产品的人，为免疑义，该终端客户包括但不限于通过网络、移动客户端购买产品的人。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">关联公司：</span>
              <span style="font-family:华文楷体; font-size:10.5pt">指任何受一方控制、控制该方或与该方受共同控制的公司或其他经营实体。为本协议之目的，“控制”指在一个实体中直接或间接拥有不低于50％的表决权。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">价格：</span>
              <span style="font-family:华文楷体; font-size:10.5pt">指乙方在甲方系统里录入的产品价格，包含但不限于成本价、销售价等均为含税价格。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">服务内容：</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲方基于转售目的拟向乙方采购产品，转售渠道和方式包括但不限于自行或委托其他主体通过网站、移动客户端终端及其他平台（“甲方平台”）向终端客户供应货物，或以其他方式向第三方进行销售。乙方同意按照本协议的约定向甲方供应产品。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">合同期限及解除：</span>
              <br style="clear:both; mso-break-type:section-break; page-break-before:always"/>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议有效期自</span>
              <span class="content">{{contract.startYear}}</span>
              <span style="font-family:华文楷体; font-size:10.5pt">年</span>
              <span class="content">{{contract.startMonth}}</span>
              <span style="font-family:华文楷体; font-size:10.5pt">月</span>
              <span class="content">{{contract.startDay}}</span>
              <span style="font-family:华文楷体; font-size:10.5pt">日开始至</span>
              <span class="content">{{contract.endYear}}</span>
              <span style="font-family:华文楷体; font-size:10.5pt">年</span>
              <span class="content">{{contract.endMonth}}</span>
              <span style="font-family:华文楷体; font-size:10.5pt">月</span>
              <span class="content">{{contract.endDay}}</span>
              <span style="font-family:华文楷体; font-size:10.5pt">
                                日截止，合同期满双方同意续约但未签署书面续约合同或另行签订合同的，双方同意本协议期限自动延续。如果双方及关联公司在此合同期内之前签署过其他推广或采购协议，之前的合同及协议内容均以此次签订的版本为最后版本。<br>
                                &nbsp;&nbsp;任何一方可在另一方严重违反本协议（包括本协议的附件、补充协议、平台规则）且收到守约方书面通知后十五（15)个工作日内未予以纠正时，书面通知另一方立即终止本协议；任何一方可以经提前六十（60）天向另一方发出书面通知而无因终止协议，乙方选择无因终止本协议的前提是乙方已经履行完毕其在本协议终止前发出的订单。
                            </span>
            </li>
          </ol>
        </li>

        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">产品销售</span>
          <p style="margin:0pt; text-align:justify"><span
                  style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist2" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">产品销售方式：甲方将通过网站、APP等各种形式向消费者销售的乙方的产品，乙方应将合作产品的图片、文字信息等资料以甲方要求的规格，上传至甲方展示平台或提交给相关人员。
                            </span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方负责合作产品的日常在线维护工作，包括但不限于商品的上架、下架、图片和文字的调整更新、产品说明性文件的展示，商品库存的监督等等。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">采购单的方式包括以下几种：系统直接下发消费者订单、合同书订单形式、电子数据订单形式、邮件等，以上所有订单形式均适用于本协议，与本合同拥有同等法律效力。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方为甲方提供的商品供货价格为含税价，结算时时，乙方应为甲方提供增值税票。乙方确认，因乙方邮费已包含在产品的含税结算价（或产品销售价格）中，该等所有费用均由乙方承担。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">产品所有权，在产品交付给消费者之前，产品的所有权归乙方所有，与此相关的风险由乙方承担。在交付给消费者后，产品所有权及风险直接转移至消费者。</span>
            </li>
          </ol>
        </li>

        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">货款结算</span>
          <p style="margin:0pt; text-align:justify"><span
                  style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist3" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">结算方式：月结。每月最后一日前，甲方将上一月度全部已生效发货订单发送给乙方工作人员核对，乙方在5个工作日内核对完毕，经甲乙双方确认无误的结算清单为甲乙双方的结算依据。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">发票的开取：乙方确认结算清单后3个工作日内，应当向甲方开具相应金额的增值税专用发票。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲方应在收到乙方开具的符合标准的发票后10个工作日内将月度货物款项支付至乙方指定银行账户。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方指定银行账户：<br></span>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">账户名称：</span>
                <span class="content">{{contract.BankTitle}}</span>
              </p>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">开户账号：</span>
                <span class="content">{{contract.BankAccount}}</span>
              </p>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">开户银行：</span>
                <span class="content">{{contract.BankName}}</span>
              </p>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲方开票信息：<br></span>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">公司名称：北京果敢时代科技有限公司</span>
              </p>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">纳税人识别号：911101053181586258</span>
              </p>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">年度返点：
                                <br>年度目标达成，甲方可享受乙方商品销售推广阶梯返点，返点金额可直接从货款里扣除，如果货款金额不足，乙方应在收到甲方通知3日内向甲方支付。具体约定如下：
                            </span>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">甲方达到年销售回款</span>
                <span class="content">{{contract.yearSaleMoney1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">元，乙方给予甲方回款额</span>
                <span class="content">{{contract.yearSaleRebateRate1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">%</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">的返点；</span>
              </p>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">甲方达到年销售回款</span>
                <span class="content">{{contract.yearSaleMoney2}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">元，乙方给予甲方回款额</span>
                <span class="content">{{contract.yearSaleRebateRate2}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">%</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">的返点；</span>
              </p>
              <p style="margin: 5pt 0pt 0pt 20pt; text-indent: 1pt;">
                <span style="font-family:华文楷体; font-size:10.5pt;">甲方达到年销售回款</span>
                <span class="content">{{contract.yearSaleMoney3}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">元，乙方给予甲方回款额</span>
                <span class="content">{{contract.yearSaleRebateRate3}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">%</span>
                <span style="font-family:华文楷体; font-size:10.5pt;">的返点；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">注：
                                    <br>阶梯返点均以年度或合同约定的其他时间段为考核周期，回款额以经甲乙双方确认的系统中结算数据为准。
                                </span>
              </p>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">因乙方未履行本协议约定或违返本协议约定的条款，对甲方造成经济损失，甲方有权直接在实际销售收入中扣除甲方实际发生的损失金额，或有权向乙方追偿；</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">合作期内最后一期款项结算后产生的用户退款金额，甲方有权直接在实际销售收入中扣除，或有权向乙方追偿。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">质保金</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist4" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方同意甲方留存货款的一部分为作为质保金（以下称“质保金”），用于担保其对本协议的履行和遵守，质保金额为【  </span>
              <span class="content">{{contract.deposit}}</span>
              <span>】元整，乙方认可甲方有权自应结账款中扣除相应金额作为质保金。甲方有权根据经营情况调整质保金额度。如本合同到期后，甲乙双方续签协议，乙方根据双方签署的原协议的质保金余额继续适用。
                            </span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲方可在以下情形发生时，处置质保金：<br>
                            </span>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（1）如因乙方产品违法、侵权、存在质量缺陷或违反本协议其他规定，造成终端用户任何损失的，甲方有权直接划扣质保金用于代甲方向终端用户退还货款、支付赔偿款；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（2）如乙方产品违法、侵权、存在质量缺陷或违反本协议其他规定，致使甲方或其关联公司权益受损（包括但不限于被行政处罚、被判决侵权、商誉受损等），甲方有权划扣质保金中的相应金额至乙方账户作为违约金和/或赔偿款；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（3）如乙方违反其与甲方或其关联公司的其他协议规定造成甲方或其关联公司损失或应支付违约金，乙方同意甲方可基于该协议规定直接划扣质保金中相应金额；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（4）其他甲方有合法合理理由可处置质保金的情况。</span>
              </p>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议履行期间，质保金的支配、使用权均归属于甲方。在乙方解散、清算、破产时，甲方在其留置的质保金范围内享有优先受偿权。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议终止时（无论任何原因），甲方有权继续留存质保金至甲方向乙方支付最后一笔结算款项后【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于产品违法、侵权、质量缺陷等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲方将质保金余额无息退还乙方。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">乙方承诺与保证</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist5" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方承诺其向通过甲方购买商品的用户（以下称“终端用户”）交付的产品（包括赠品）应为其合法生产或有权经销的、符合《中华人民共和国产品质量》的相关规定，符合国家质量标准或行业标准及双方约定的标准，该等商品不存在侵犯任何第三方权益。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方承诺其在向终端用户提供服务的过程中，将严格遵守《中华人民共和国消费者权益保护法》等相关法律法规的规定，乙方保证不存在以下欺诈行为：<br></span>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">a.骗取消费者价款或者费用而不提供或者不按照约定提供商品或者服务；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">b.在产品中掺杂、掺假、以假充真、以次充好或以不合格产品冒充合格产品；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">c.供应国家明令淘汰的产品或者失效、变质的产品；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">d.伪造产品的产地，伪造或者冒用他人的厂名、厂址，伪造或者冒用认证标志、名优标志等质量标志；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">e.依法需强制检验或认证的，未履行检验或认证手续或者伪造检验或认证结果；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">f.提供的产品中出现已拆封的产品或“空盒”产品（含缺少配件、说明书等随机附件）；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">g.其他国家法律法规明文禁止的欺诈行为。</span>
              </p>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方承诺其在向终端客户提供服务的产品中，将严格遵守《中华人民共和国民法典》《中华人民共和国消费者权益保护法》的规定，不得恶意损害终端用户的合法权益，否则乙方有权按照本协议的约定，采取相应措施。 </span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方承诺其在为终端用户提供服务的过程中，将严格按照双方约定的时间和数量向终端用户提供服务，因未按照双方约定发货或未发货导致的相关责任，乙方自行承担，与甲方无关。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方承诺其为终端用户提供的服务（包括赠品和实物产品）的退换保修等售后工作由甲方自行负责，甲方可以提供必要的协助。如乙方发现其提供的产品存在严重缺陷，即使正确使用仍然可能对人身、财产安全造成危害的，应当立即告知甲方，并采取有效防止危害的措施，包括但不限于召回。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方承诺其在本协议有效期内及本协议履行完毕后的任何时间，应当尊重和维护甲方的声誉，不得从事可能导致甲方声誉受损的行为。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方承诺其对于与终端用户之间产生的争议和纠纷应当积极妥善予以解决，由此产生的责任（包括但不限于赔偿责任等）由乙方自行承担，乙方不得恶意引导用户向甲方索赔，否则甲方要求乙方承担相应的违约责任，同时有权就其遭受的损失向乙方追偿。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">产品交付</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist6" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方负责向消费者发货并承担运费，乙方应在甲方将订单信息提交给乙方的48小时内向消费者发货，乙方应将物流单号反馈给甲方并确保商品出库（物流系统有揽件信息）。因不可抗力等原因导致无法按照合同约定发货，乙方应在本合同约定的发货时间前及时通知甲方。若因乙方原因，未按照合同约定及时向消费者发货，由此给甲方带来的损失由乙方承担。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方应当按照甲方提供的订单信息向消费者进行发货，因乙方原因造成的错发、漏发产生的退换货，补发、拦截快递等费用，由乙方承担。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">产品毁损、灭失的风险按照相关国家相关法律、法规的规定进行处理。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方应按甲方相关要求的包装对产品进行包装，包装制作费用由乙方负责，在包装中附带甲方要求的材料、不夹带任何未经甲方同意的资料、宣传单以及发货单中不得出现任何非甲方的第三方网站或店铺信息等。如有违反，一经甲方发现，乙方将按每一单1000元的标准向甲方支付违约金。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方不得私下与甲方平台的用户进行私下交易，如有违规，一经发现，乙方将按每一单1000元的标准向甲方支付相关违约金。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">甲方权利义务</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist7" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲方有权对乙方向终端客户提供的服务进行监督，并在接到终端用户的反馈、举报、投诉时，要求乙方提供相关的后台数据资料，针对该等情况予以调查。经甲方调查认为乙方存在不合理或者违法行为的，有权要求乙方在【7】个工作日内予以整改。乙方拒不整改或者乙方整改后仍然存在不合理或者违法情况的，甲方有权根据本协议第约定采取相应的措施。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">双方对与本合同项目直接有关的一切数据、纪要、文档等信息负有保密义务，未经另外一方书面同意，不得向第三方泄露或对外用于与本合同无关的目的，但按法律规定或政府部门要求而作出的披露除外。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲以方需按照乙方要求、本合同及附件、行业标准合法审慎履行服务，并不得侵犯任何第三方的合法权益。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">除为本协议之目的，甲方不得使用或允许任何其它一方使用属于乙方或乙方客户的知识产权，包括但不止于商标、企业名称、产品包装等。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方尊重和保护消费者权利。涉及消费者权益的，甲乙双方遵照《中华人民共和国消费者权益保护法》及相关法律、法规的规定执行。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">乙方的权利义务</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist8" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方具有签订和履行本协议所需的所有合法资格、资质和能力，包括应持有中国法律、法规所要求的一切证明、批准、许可和其他任何证明文件，而且应为商品的生产商或授权经销商。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方提供给甲方的产品来源正当合法，均为全新正品行货。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方对其所提供产品享有唯一的合法的所有权，并且产品在本协议项下的推广和销售未侵犯任何第三方的权利，包括但不限于第三方的知识产权。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方必须严格遵守甲方对本协议项下合作产品的限价规定，双方共同维护市场稳定。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方尊重各自旗下品牌形象发展，双方保证经营活动中互不侵犯彼此合法权益。任何一方应尽商业上合理的努力保证维护其他方的声誉及形象，不得制作有损其他方的任何作品、文字、图案等信息资料。合作期间甲方有权在自有销售平台上使用乙方的相关logo、产品图片、宣传材料，具体以乙方提供内容为准，但未经乙方许可，甲方不得将上述材料擅自修改或用作推广以外的其他用途，更不得授权第三方使用。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">知识产权</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist9" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方应保证与产品相关的专利、商标、名称、版权、特有标识、装潢、技术秘密等均属于其权利人所有。乙方应保证其已按照法律规定或者合同约定获得了向甲方销售产品的权利或许可，该等权利或许可不与任何排他性权利相冲突。 乙方确保甲方销售该产品不会导致任何第三方主张侵权或其他妨碍甲方销售的行为，否则，产生的一切纠纷与甲方无关，给甲方造成损失的，乙方应当进行赔偿。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方或其代表对根据本合同提供给甲方的所有原始数据和资料、课程、推广文案等保有所有权和知识产权。非经乙方书面同意，甲方不得复制、传播前述数据和资料用作其他用途。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">消费者权益保护</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist10" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">为保障消费者的合法权益，根据《中华人民共和国消费者权益保护法》的有关规定，甲乙双方保证不侵害消费者的合法权利，妥善处理消费者的合理诉求。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">涉及乙方在向终端用户提供服务的过程中，实施侵害消费者权益的行为，包括但不限于单方面更改规则，泄漏用户信息等，甲方有权解除合同，同时乙方同意甲方有权将应当支付给甲方的剩余【未结算的全部款项】作为惩罚性违约金，并就甲方因此遭受的损失（包括但不限于赔偿用户造成的损失以及因甲方相应行为遭受的名誉损失）承担相应的赔偿责任。同时，甲方有权根据终端用户的要求，划扣乙方的质保金对该等用户予以补偿，质保金不足以支付用户赔偿的，甲方予以垫付的部分有权直接从应付乙方的款项中予以扣减或者要求乙方一次性无条件予以补偿。乙方相关行为涉嫌欺诈的，甲方有权向法院及工商部门举报。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">保密</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist11" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">协议双方同意在本协议履行中所知悉之对方商业、技术、营运状况及其他一方要求对方保密的信息，均为对方之机密信息，除非得到对方事先书面同意，本协议任意一方不得将该机密信息泄露或交付予任何第三人。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">协议双方同意，未经甲方同意，乙方不得向任何第三方披露本协议的合作关系及所有合作内容。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">双方同意，不论本协议是否无效、变更、解除、终止或不具操作性，本条规定的保密义务在本协议有效期限及本协议届满或终止后五（5）年均有效。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">反商业贿赂</span>
          <p style="margin:0pt; text-align:justify"><span
                  style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist12" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">双方应严格遵守现行有效的法律法规，拒绝商业贿赂、行贿及其他任何之不正当商业行为。供应商不得向果敢时代及其成员提供或许诺提供、果敢时代及其成员亦不得要求供应商向其提供或许诺提供任何形式的不正当利益，包括但不限于现金、银行存 单、支票、旅行支票、购物卡、礼券、打折卡、会员卡等现金等价物和有价证券、 借款、实物、费用报销、服务、礼品和招待或任何其他形式的便利或利益。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">如果甲方发现乙方及其关联方存在任何违反本条第一款约定的行为，甲方有权终止本合同及任何相关合同，且终止立即生效，已收取的费用包括但不限于商品销售款项及质保金将不退还，造成甲方损失的，应当赔偿。同时乙方保留追究甲方、甲方相关工作人员法律责任的权力。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">不可抗力</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist13" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">任何一方因其无法控制的原因，包括战争、火灾、封锁、罢工（不包括其自身员工的罢工）或自然灾害而导致其无法履行协议项下的义务时，该方对另一方因上述不履行而导致的损失或损害不承担责任。一方在知道可能导致援引本条的事件发生时应当立即通知另一方。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">如果本协议任意一方连续十五（15）个自然日无法充分履行其责任，相对方可以在发出书面通知十五（15）个自然日后终止本协议或终止受该因素影响的部分，其他未终止的部分效力不受影响。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">完整协议</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist14" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议构成各方就协议标的所达成的全部约定及谅解。除非本协议另有明确说明，取代并废除各方在此之前所达成的所有口头或书面协议、声明、陈述、谅解、谈判及讨论。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">各方承认并同意，各方签署本协议并未依赖在此协议之前作出的所有声明、陈述、担保或谅解，除非该等声明、陈述、担保或谅解已被纳入本协议中。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">通知</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist15" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议规定的通知送达地址或其他通讯方式的地址在合同首部双方信息栏内列明。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议所要求的所有通知均必须以书面形式发送至收件方意图送达的地址，或依照双方约定的其他地址向另一方发出通知。通知可以采用挂号邮件或同类方式、传真、快件或其他电子传输方式。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">协议的终止</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist16" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">在本合同有效期内，如遇国家法律、法规、政策及行业管理规定影响到本合同有关条款的执行，则双方应按照国家及行业有关规定进行相应调整。由于任意一方的政府主管单位或上级主管单位的政策调整使得合同不可继续履行，经协商一致，双方可以书面方式终止合作。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">如出现本协议中约定的不可抗力之情形，受阻方应及时采取合理措施防止损失的扩大。如不可抗力持续超过三十（30）个自然日，双方可经协商一致以书面方式终止协议。因不可抗力致使协议无法履行的，双方免责。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">在下述情况下，任何一方（以下简称“第一方”）均可在书面通知另一方后立即终止本协议：</span>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（1）另一方停业、清算（事先得到第一方书面同意的、为善意破产的重建或合并之目的而进行的自愿清算除外）或解散；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（2）另一方的控制权发生变化；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（3）另一方无法支付到期债务，或其全部或部分财产被指定给破产接管人、行政接管人或管理人（或依照其公司所在地或公司设立地的法律规定的任何类似官员或程序）接管，或正面临任何破产程序；</span>
              </p>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">在本协议合作期间，如任何一方违反本协议约定，守约方有权要求违约方改正违约行为。如违约方在收到守约方要求其改正的通知后五个工作日内仍不改正违约行为，守约方有权单方解除本协议并要求违约方赔偿因此给守约方造成的直接损失。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">经甲方提前30日书面通知乙方后，甲方有权单方解除协议，双方按照实际产生的收益进行结算。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">违约责任</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist17" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">如果甲乙双方任一方违反本协议规定，导致守约方遭受损失的，违约方根据本协议规定承担相应的违约责任以及承担因维权产生的相关费用，包括但不限于律师费、诉讼费等。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">乙方供应产品（包括赠品）不符合协议约定标准的（包括不限存在数量短溢、型号规格不符、未按期交货或其他质量瑕疵等）或违反本协议保证的，应承担所涉及未结算的全部款项的违约金，违约金不足以弥补对甲方造成的损失的，乙方还应承担赔偿责任。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">如甲方发现乙方提供产品有本协议规定的涉嫌欺诈的情形，甲方有权要求乙方支付所涉订单总额十倍的违约金，违约金不足以弥补对甲方造成的损失的，乙方还应承担赔偿责任。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">若因乙方违反本协议的有关规定而导致第三方向甲方予以索赔、主张权利、提出异议，乙方应当直接与该第三方交涉直至此事的解决，并赔偿甲方由此产生的全部损失，包括但不限于甲方因此所遭受的名誉损失。同时，乙方应按甲方的要求采取措施以停止侵害、恢复名誉、消除影响等。</span>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">终止的效力</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist18" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt -10.35pt; text-indent:0pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议的终止对双方在终止日之前所产生的任何权利不产生任何影响。同时，协议的终止权并非唯一救济手段，而是对包括损害赔偿请求权以及依照本协议规定所能采取的其他各种补救措施或权利的补充。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议双方承诺，协议终止后，应在收到对方书面通知后五（5）个工作日内依照对方的要求：</span>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（1）返还其拥有或控制的对方的全部财产，乙方因协议约定而存有的质保金除外；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（2）返还其拥有的对方的所有机密信息及其所有副本；</span>
              </p>
              <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                <span style="font-family:华文楷体; font-size:10.5pt">（3）对其拥有、保管或控制的所有文件及其他材料进行粉碎或焚毁，以销毁其拥有的对方的所有机密信息，并向对方证明已采取上述措施。</span>
              </p>
            </li>
          </ol>
        </li>
        <li style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; list-style-position:inside; margin:10pt 0pt 0pt 31.5pt; text-indent:-28.35pt">
          <span style="font:7.0pt 'Times New Roman'">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">其他</span>
          <p style="margin:0pt; text-align:justify"><span
              style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
          </p>
          <ol type="1" class="awlist19" style="margin-left:-17pt; padding-left:0pt">
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议受中华人民共和国法律管辖。对于因本协议而产生的任何争议，双方均应努力通过友好协商的方式进行解决。如无法就争议解决达成一致，任何一方均可向合同签订地人民法院提起诉讼。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议一方未经另一方事先书面同意不得将其本协议项下的权利和义务全部或部分转让给任何第三方。尽管有前述规定，甲方同意，乙方可将本协议（或其在本协议项下的任何权利或义务）转让给其关联公司，或当发生合并、重组、出售全部或重要资产或类似交易时转让给其后续公司。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议无论因任何原因终止，除协议中已有规定外，产品质量、知识产权、保密、保证和承诺、违约责任条款在协议终止后将继续有效。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">本协议内容包括协议正文、附件、补充协议以及乙方不时修订的平台规则。任何对本协议的修订一经生效即构成协议各方权利义务的补充，并成为本协议的一部分。本协议经双方授权代表签署并加盖双方公章或合同章后生效。本协议一式贰（2）份，甲乙双方各执壹（1）份，具有同等效力。</span>
            </li>
            <li style="font-family:华文楷体; font-size:10.5pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt;padding-left: 7pt;">
              <span style="font:7.0pt 'Times New Roman'">&nbsp;</span>
              <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方在本协议生效前签订的协议在本协议生效后即时终止。未完成事项可由双方参考本协议约定事项进行处理。</span>
            </li>

          </ol>
        </li>
      </ol>


      <p style="margin:7.8pt 0pt 0pt; text-align:center">
        <span style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">&nbsp;</span>
      </p>

      <p style="margin:7.8pt 0pt 0pt; text-align:center">
        <span style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">[以下无正文]</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">&nbsp;</span></p>
      <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">&nbsp;</span></p>
      <p style="margin:7.8pt 0pt 0pt; text-align:center"><span
          style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>

      <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:464.3pt">
        <tr style="height:96.8pt">
          <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:264pt">
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">甲方（盖章）：</span>
              <span class="content">{{contract.Asign}}</span>
            </p>
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">签约日期:</span>
              <span class="content">{{contract.AsignYear}}</span>
              <span style="font-family:楷体; font-size:10.5pt">年</span>
              <span class="content">{{contract.AsignMonth}}</span>
              <span style="font-family:楷体; font-size:10.5pt">月</span>
              <span class="content">{{contract.AsignDay}}</span>
              <span style="font-family:楷体; font-size:10.5pt">日</span>
            </p>
          </td>
          <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:200pt">
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">乙方（盖章）：</span>
              <span class="content">{{contract.Bname}}</span>
            </p>

            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0"><span
                style="font-family:楷体; font-size:10.5pt">&nbsp;</span></p>
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0"><span
                style="font-family:楷体; font-size:10.5pt">&nbsp;</span></p>
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0"><span
                style="font-family:楷体; font-size:10.5pt">&nbsp;</span></p>
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
              <span class="content">{{contract.BsignYear}}</span>
              <span style="font-family:楷体; font-size:10.5pt">年</span>
              <span class="content">{{contract.BsignMonth}}</span>
              <span style="font-family:楷体; font-size:10.5pt">月</span>
              <span class="content">{{contract.BsignDay}}</span>
              <span style="font-family:楷体; font-size:10.5pt">日</span>
            </p>
          </td>
        </tr>
        <tr>
          <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
              <span class="content">{{contract.Adeputy}}</span>
            </p>
          </td>
          <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
            <p style="font-size:10.5pt; line-height:115%; margin:7.8pt 0pt; orphans:0; widows:0">
              <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
              <span class="content">{{contract.Bdeputy}}</span>
            </p>
          </td>
        </tr>
      </table>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
          style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>
      <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
          style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>

      <p style="margin:0pt; text-align:center"><br style="page-break-before:always; clear:both"/>
        <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件一 甲方资质证明文件清单</span>
      </p>

      <p style="margin:7.8pt 0pt 0pt; text-align:justify"><span
          style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>

      <table cellspacing="0" cellpadding="0"
             style="border-collapse:collapse;float:left; margin:0pt 9pt; width:387.45pt">
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">文件名称</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">资质要求及涉及类别</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top;">
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">1.</span>
            </p>
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
          </td>
          <td colspan="4" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">基本资质证件</span>
            </p>
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.1</span>
            </p>
          </td>
          <td colspan="2"
              style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt;">
            <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">营业执照副本</span>
            </p>
          </td>
          <td colspan="2"
              style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt;">
            <p style="margin:0pt;orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">必须具有独立法人资格；如为分支机构，不具有独立法人资格，需提供总公司授权书；</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.2</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">法定代表人身份证</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">有效期内，正反面复印；</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.3</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">税务登记证（三证合一后无需提供）</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.4</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">组织机构代码证（三证合一后无需提供）</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.5</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">一般纳税人认定证书</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.6</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">开户银行许可证</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.7</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">商标注册证</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.8</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">品牌授权销售代理协议或证明</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">如为品牌代理商，须提供生产商、品牌商或商标专有权人授权销售证明文件</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">1.9</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">进口货物报关单</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">海关出具的注有进口数量、成交总价的凭证</span>
            </p>
          </td>
        </tr>

        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top;">
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">2.</span>
            </p>
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
          </td>
          <td colspan="4" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
            <p style="margin:0pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
              <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">特许经营资质文件</span>
            </p>
            <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">2.1</span>
            </p>
          </td>
          <td colspan="2"
              style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt;">
            <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证</span>
            </p>
          </td>
          <td colspan="2"
              style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt;">
            <p style="margin:0pt;orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">食品</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">2.2</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证、保健食品批准证书以及保健食品生产企业批准证书、进口保健食品批准证书（如为进口保健食品）</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">保健食品</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">2.3</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">出版物经营许可证</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">出版物、音像制品、电子出版物</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">2.4</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">医疗器械经营许可证</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">第二类医疗器械</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">2.5</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">批次化妆品检验报告；特殊用途化妆品卫生批准文件（如为特殊用途化妆品）；生产厂家卫生许可证复印件以及生产厂家生产许可证复印件</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">国产化妆品</span>
            </p>
          </td>
        </tr>
        <tr style="height:4.5pt">
          <td style="padding-left:5.4pt;vertical-align:top;">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt;">2.6</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
            <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">进口化妆品卫生许可批件；进口化妆品厂家检验报告；进口检验检疫部门检验报告以及标签审核证书</span>
            </p>
          </td>
          <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
            <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
              <span style="font-family:华文楷体; font-size:10.5pt"></span>
              <span style="font-family:华文楷体; font-size:10.5pt">进口化妆品</span>
            </p>
          </td>
        </tr>

      </table>
      <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>
      <p style="margin:0pt; text-align:center"><br style="page-break-before:always; clear:both"/>
        <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件二 商品清单</span>
      </p>

      <p style="margin:0pt">
        <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
      </p>

      <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt">
        <tr>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <p style="margin:0pt; text-align:justify">
              <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品名称</span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <p style="margin:0pt; text-align:justify">
              <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">计量单位</span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <p style="margin:0pt; text-align:justify">
              <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品单价（元）</span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <p style="margin:0pt; text-align:justify">
              <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品数量</span>
            </p>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <p style="margin:0pt; text-align:justify">
              <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">总价（元）</span>
            </p>
          </td>
        </tr>
        <tr v-for="goods in contract.purchaseGoodsList">
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <span>{{goods.goodsName}}</span>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <span>{{goods.goodsUnit}}</span>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <span>{{goods.goodsPrice}}</span>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <span>{{goods.goodsNumber}}</span>
          </td>
          <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
            <span>{{goods.goodsTotalMoney}}</span>
          </td>
        </tr>
        <tr>
          <td colspan="5"
              style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:451.45pt">
            <p style="margin:0pt; text-align:justify">
              <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">合计（元）：</span>
              <span>{{contract.purchaseTotalMoney}}</span>
            </p>
          </td>
        </tr>
        <tr>
          <td colspan="5"
              style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:451.45pt">
            <p style="margin:0pt; text-align:justify">
              <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">其他：</span>
              <span>{{contract.purchaseOther}}</span>
            </p>
          </td>
        </tr>
      </table>

      <p style="margin:0pt; text-align:justify">
        <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
      </p>
    </div>
    <div style="padding:20px 0px 15px 0px;text-align: center">
      <el-button type="primary" @click="htmlPrint()">打 印</el-button>
      <el-button type="primary" @click="returnWindow()">返 回</el-button>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  data () {
    return {
      agreementCode: "",
      contract: {
        code:"",
        name:"北京果敢时代科技有限公司",
        year:"",
        month:"",
        day:"",
        Aname:"北京果敢时代科技有限公司",
        Aaddress:"北京市朝阳区酒仙桥路14号50号楼 A2-1门3层301",
        Auser:"吴方华",
        Amobile:"",
        Aemail:"wufanghua@davdian.com",
        Bname:"",
        Baddress:"",
        Buser:"",
        Bmobile:"",
        Bemail:"",
        startYear:"",
        startMonth:"",
        startDay:"",
        endYear:"",
        endMonth:"",
        endDay:"",
        AankTitle:"北京果敢时代科技有限公司",
        AankName:"招商银行股份有限公司北京望京支行",
        AankAccount:"110915262610114",
        BankTitle:"",
        BankName:"",
        BankAccount:"",
        concession :"",
        yearSaleMoney1:"",
        yearSaleRebateRate1:"",
        yearSaleRebateMoney1:"",
        yearSaleMoney2:"",
        yearSaleRebateRate2:"",
        yearSaleRebateMoney2:"",
        yearSaleMoney3:"",
        yearSaleRebateRate3:"",
        yearSaleRebateMoney3:"",
        deposit:"",
        Asign:"北京果敢时代科技有限公司",
        AsignYear:"",
        AsignMonth:"",
        AsignDay:"",
        BsignYear:"",
        BsignMonth:"",
        BsignDay:"",
        Adeputy:"吴方华",
        Bdeputy:"",
        purchaseTotalMoney:"",
        purchaseOther:"",
        purchaseGoodsList:[
          {
            goodsName:"",
            goodsUnit:"",
            goodsPrice:"",
            goodsNumber:"",
            goodsTotalMoney:""
          }
        ]
      }
    }
  },
  mounted () {
    this.$router.app.showMenu = false;
    var contentId = this.$route.query.contentId;
    var parentContractId = this.$route.query.parentContractId;
    var agreementCode = this.$route.query.agreementCode;
    var type = this.$route.query.type;
    this.parentContractId = parentContractId;
    if (agreementCode !== "") {
      this.contract.code = agreementCode;
    }
    this.initContent(contentId, type);
  },
  methods: {
    returnWindow(){
      window.close();
    },
    htmlPrint(){
      $("#content").jqprint();
    },
    initContent(contentId, type){
      var that = this;
      $.get({
        url: '/suppliers/contract/template/content',
        data: {
          contentId: contentId,
          type: type
        },
        success: function (result) {
          if (!result.code) {
            that.contract = result.data;
            if (!that.parentContractId) {
              if (!that.contract.contractYear) {
                //that.contract.contractYear = "2017";
              }
            } else {
              if (!that.contract.contractYear) {
                //that.contract.contractYear = "2018";
              }
            }
          } else {

          }
        }
      })
    }
  },
  computed: {
    amount: function () {
      return 200 - this.addForm.brandDesc.length;
    }
  }
}
</script>
<style type="text/css" lang="less" scoped>
input {
  border-width: 0px 0px 1pt 0px;
  border-bottom-color: #ff0000;
  text-align: center;
  font-size: 14px;
}

.awlist1 {
  counter-reset: awlistcounter1;
  list-style-type: none
}

.awlist1 li:before {
  content: "1." counter(awlistcounter1);
  counter-increment: awlistcounter1
}

.awlist2 {
  counter-reset: awlistcounter2;
  list-style-type: none
}

.awlist2 li:before {
  content: "2." counter(awlistcounter2);
  counter-increment: awlistcounter2
}

.awlist3 {
  counter-reset: awlistcounter3;
  list-style-type: none
}

.awlist3 li:before {
  content: "3." counter(awlistcounter3);
  counter-increment: awlistcounter3
}

.awlist4 {
  counter-reset: awlistcounter4;
  list-style-type: none
}

.awlist4 li:before {
  content: "4." counter(awlistcounter4);
  counter-increment: awlistcounter4
}

.awlist5 {
  counter-reset: awlistcounter5;
  list-style-type: none
}

.awlist5 li:before {
  content: "5." counter(awlistcounter5);
  counter-increment: awlistcounter5
}

.awlist6 {
  counter-reset: awlistcounter6;
  list-style-type: none
}

.awlist6 li:before {
  content: "6." counter(awlistcounter6);
  counter-increment: awlistcounter6
}

.awlist7 {
  counter-reset: awlistcounter7;
  list-style-type: none
}

.awlist7 li:before {
  content: "7." counter(awlistcounter7);
  counter-increment: awlistcounter7
}

.awlist8 {
  counter-reset: awlistcounter8;
  list-style-type: none
}

.awlist8 li:before {
  content: "8." counter(awlistcounter8);
  counter-increment: awlistcounter8
}

.awlist9 {
  counter-reset: awlistcounter9;
  list-style-type: none
}

.awlist9 li:before {
  content: "9." counter(awlistcounter9);
  counter-increment: awlistcounter9
}

.awlist10 {
  counter-reset: awlistcounter10;
  list-style-type: none
}

.awlist10 li:before {
  content: "10." counter(awlistcounter10);
  counter-increment: awlistcounter10
}

.awlist11 {
  counter-reset: awlistcounter11;
  list-style-type: none
}

.awlist11 li:before {
  content: "11." counter(awlistcounter11);
  counter-increment: awlistcounter11
}

.awlist12 {
  counter-reset: awlistcounter12;
  list-style-type: none
}

.awlist12 li:before {
  content: "12." counter(awlistcounter12);
  counter-increment: awlistcounter12
}

.awlist13 {
  counter-reset: awlistcounter13;
  list-style-type: none
}

.awlist13 li:before {
  content: "13." counter(awlistcounter13);
  counter-increment: awlistcounter13
}

.awlist14 {
  counter-reset: awlistcounter14;
  list-style-type: none
}

.awlist14 li:before {
  content: "14." counter(awlistcounter14);
  counter-increment: awlistcounter14
}

.awlist15 {
  counter-reset: awlistcounter15;
  list-style-type: none
}

.awlist15 li:before {
  content: "15." counter(awlistcounter15);
  counter-increment: awlistcounter15
}

.awlist16 {
  counter-reset: awlistcounter16;
  list-style-type: none
}

.awlist16 li:before {
  content: "16." counter(awlistcounter16);
  counter-increment: awlistcounter16
}

.awlist17 {
  counter-reset: awlistcounter17;
  list-style-type: none
}

.awlist17 li:before {
  content: "17." counter(awlistcounter17);
  counter-increment: awlistcounter17
}

.content {
  font-family: 华文楷体;
  font-size: 10.5pt;
  border-bottom: 1px solid #ff4a7d;
}
</style>


// WEBPACK FOOTER //
// contract_15.vue?bead9c42